module.exports = __webpack_public_path__ + "static/media/time-tracking.48e9f842.svg";